import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementWithApprovalFlow } from "./selectorIsRequirementWithApprovalFlow";
import { selectorIsRequirementPendingApproval } from "./selectorIsRequirementPendingApproval";

export const selectorIsRequirementPostApproval = (
  requirement: IRequirementResponse
) => {
  const isApprovalStrategy = selectorIsRequirementWithApprovalFlow(requirement);

  const isNotWaitingForApprovalNow =
    !selectorIsRequirementPendingApproval(requirement);

  const isStatusAlreadyOverridden = !!requirement.payerOverrideStatus;

  return (
    isApprovalStrategy &&
    isNotWaitingForApprovalNow &&
    isStatusAlreadyOverridden
  );
};
